import { useContext } from "react";
import { useHistory } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import { TestAnalysisContext } from "../../contexts/test-analysis.context";
import PageSpinner from "../../_components/page-spinner/PageSpinner";

import "./test-analysis.styles.css";

const TestAnalysisSummary = () => {
  const history = useHistory();

  const { testDetails, isLoading } = useContext(TestAnalysisContext);
  console.log(testDetails);
  const goBack = () => {
    history.goBack();
  };

  const openCategory = (id)=>{
    history.push(`testAnalysis/${id}`)
  }

  return isLoading ? (
    <PageSpinner />
  ) : (
    <div>
      <div className="category-header">
        {" "}
        <FontAwesomeIcon
          icon={faArrowLeft}
          onClick={goBack}
        />
        <span className="category-header-text">Test Analysis</span>
      </div>
      <main className="test-details-wrapper">
        {testDetails?.map((testDetail, i) => {
          const tests = testDetail.tests.slice(0, 5);
          return (
            <div className="test-analysis-category-wrapper" key={i}>
              <span className="test-analysis-category-name">
                {testDetail.name}
              </span>
              <div className="test-analysis-test-container test-analysis-test-detail">
                <span>S.No</span>
                <span>Name</span>
              </div>
              {tests.map((test, j) => (
                <div className="test-analysis-test-container" key={j}>
                  <span>{j + 1}</span>
                  <span>{test.name}</span>
                </div>
              ))}
              <div>
                <div className="test-analysis-button-wrapper">
                  <span onClick={()=>openCategory(testDetail.id)} className="test-analysis-more-button">more..</span>
                </div>
              </div>
            </div>
          );
        })}
      </main>
    </div>
  );
};

export default TestAnalysisSummary;
